module.exports = __webpack_public_path__ + "static/media/pt.e9bf31ab.svg";